// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-image-container[data-v-2ca38fc8]{width:240px;margin-top:-40px;margin-right:-40px}.menu-image[data-v-2ca38fc8]{width:100%;height:calc(100% + 40px);max-height:400px;background-size:cover;background-position:50%;background-repeat:no-repeat;transition:background-image .2s linear}.scrollbar-thin[data-v-2ca38fc8]{scrollbar-width:thin}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
